import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberSpaceMembershipRequestKey } from '../../utils/keys';
export const useMemberSpaceMembershipRequest = (options) => {
    const { fields = 'basic', useQueryOptions, variables } = options;
    const { client } = useTribeClient();
    const memberSpaceMembershipRequest = getMemberSpaceMembershipRequestKey({
        variables,
        fields,
    });
    return useQuery(memberSpaceMembershipRequest, () => client.spaceMembership.getMemberRequests(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useMemberSpaceMembershipRequest.js.map